import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import { configureStore } from "@reduxjs/toolkit";

import { thunk } from "redux-thunk";
import authReducer from "./Auth/reducer";
import purchaseReducer from "./Purchase/reducer";
import salesReducer from "./Sales/reducer";
import loadReducer from "./Load/reducer";
import commonReducer from "./Common/reducer";
import bookingReducer from "./Booking/reducer";
import addressReducer from "./Address/reducer";
import ratequoteReducer from "./RateQuote/reducer";
import importRateQuoteReducer from "./ImportRateQuote/reducer";
import loaderReducer from "./Loader/reducer";

import vesselReducer from "./Masters/vessel/reducer";
import commodityReducer from "./Masters/commodity/reducer";
import clauseReducer from "./Masters/clause/reducer";
import countryClauseReducer from "./Masters/countryclause/reducer";
import chargesCodeReducer from "./ChargesCode/reducer";
import { toastReducer } from "./Toast/reducer";
import PortPlaceReducer from "./Masters/PortPlace/reducer";
import locationReducer from "./Masters/location/reducer";
import ImportbookingReducer from "./ImportBooking/reducer";
import BookinRquestReducer from "./BookingRequest/reducer";
import UsersReducer from "./Masters/users/reducer";
import AllModulesReducer from "./Modules/reducer";
import MasterCompanyReducer from "./Masters/company/reducer";
import BaseModulesReducer from "./Modules/baseModules/reducer";
import modulesReducer from "./Modules/modules/reducers";
import subModulesReducer from "./Modules/subModules/reducers";
import fclExportReportsReducer from "./FCLExportReports/reducer";
import fclImportReportsReducer from "./FCLImportReports/reducer";
import baseNavigationsReducer from "./features/baseNavigation/baseNavigationSlice";
import navigationsReducer from "./features/navigation/navigationSlice";
import subNavigationsReducer from "./features/subNavigation/subNavigationSlice";
import accountTypeReducer from "./features/accountType/accountTypeSlice";

const getLocalStorageItem = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

const preloadedState = {
  auth: {
    userDetails: getLocalStorageItem("authUser"),
    userToken: localStorage.getItem("token") || null,
    isLoading: false,
    currentLocation: "",
  },
};

const rootReducer = combineReducers({
  auth: authReducer,
  purchase: purchaseReducer,
  sales: salesReducer,
  load: loadReducer,
  common: commonReducer,
  booking: bookingReducer,
  addressBook: addressReducer,
  rateQuote: ratequoteReducer,
  loader: loaderReducer,
  vessel: vesselReducer,
  commodity: commodityReducer,
  clause: clauseReducer,
  countryClause: countryClauseReducer,
  chargesCode: chargesCodeReducer,
  PortPlace: PortPlaceReducer,
  toast: toastReducer,
  locations: locationReducer,
  importRateQuoteReducer: importRateQuoteReducer,
  importBooking: ImportbookingReducer,
  bookinRquest: BookinRquestReducer,
  users: UsersReducer,
  allModules: AllModulesReducer,
  baseModules: BaseModulesReducer,
  modules: modulesReducer,
  subModules: subModulesReducer,
  masterCompany: MasterCompanyReducer,
  fclExportReports: fclExportReportsReducer,
  fclImportReports: fclImportReportsReducer,
  baseNavigations: baseNavigationsReducer,
  navigations: navigationsReducer,
  subNavigations: subNavigationsReducer,
  accountType: accountTypeReducer,
});

// const composeEnhancers =
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// const store = createStore(
//     rootReducer,
//     preloadedState,
//     composeEnhancers(
//         applyMiddleware(thunk)
//     )
// );

const store = configureStore({
  reducer: rootReducer,
  preloadedState,
  devTools: process.env.NODE_ENV !== "production",
});

// store.subscribe(() => {
//     console.log('Current store state:', store.getState());
// });

export default store;
